function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8343C8"
    },
    d: "M41.754,27.958l-8.455,9.699C33.109,37.875,32.834,38,32.545,38H26.37 c-0.239,0-0.47,0.085-0.651,0.241l-6.438,5.519C19.1,43.915,18.869,44,18.63,44H17c-0.552,0-1-0.448-1-1v-4c0-0.552-0.448-1-1-1H7 c-0.552,0-1-0.448-1-1V15.943c0-0.156,0.036-0.309,0.106-0.448l3.981-7.943C10.257,7.214,10.603,7,10.981,7H41c0.552,0,1,0.448,1,1 v19.301C42,27.543,41.913,27.776,41.754,27.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M39,26.369c-1.667,1.877-3.333,3.754-5,5.631c-2.333,0-4.667,0-7,0c-2.333,2-4.667,4-7,6c0-2,0-4,0-6 c-2.667-0.008-5.333-0.016-8-0.024C12,24.65,12,17.325,12,10c9,0,18,0,27,0C39,15.456,39,20.912,39,26.369z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    style: {
      fill: "#8343C8"
    },
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    style: {
      fill: "#8343C8"
    },
    width: 3,
    height: 10
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.4b78ffb4e946109a98f01c7b8c61c788.svg";
export { ForwardRef as ReactComponent };